(()=> {
  const measureAt=(el,size)=>{
    const clone=el.cloneNode(true);
    clone.removeAttribute('data-ey-fit-text');
    clone.style.cssText += ';position:fixed!important;left:-100000px!important;top:-100000px!important;visibility:hidden!important;pointer-events:none!important;width:max-content!important;min-width:0!important;max-width:none!important;white-space:nowrap!important;transform:none!important;margin:0!important;font-size:'+size+'px!important;';
    document.body.appendChild(clone);
    const width=clone.getBoundingClientRect().width;
    clone.remove();
    return width;
  };

  const fitOne=(el)=>{
    const min=Number(el.dataset.eyFitMin||48);
    const max=Number(el.dataset.eyFitMax||520);
    const pad=Number(el.dataset.eyFitPad||0);
    const available=Math.max(0,el.getBoundingClientRect().width-pad);
    if(!available) return;

    let lo=min, hi=max, best=min;
    for(let i=0;i<18;i++){
      const mid=(lo+hi)/2;
      const width=measureAt(el,mid);
      if(width<=available*.992){best=mid;lo=mid}else{hi=mid}
    }
    el.style.fontSize=best.toFixed(2)+'px';
  };

  const fitAll=()=>document.querySelectorAll('[data-ey-fit-text]').forEach(fitOne);
  const boot=()=>{
    fitAll();
    requestAnimationFrame(fitAll);
    setTimeout(fitAll,160);
    if('ResizeObserver' in window){
      const ro=new ResizeObserver(entries=>entries.forEach(e=>fitOne(e.target)));
      document.querySelectorAll('[data-ey-fit-text]').forEach(el=>ro.observe(el));
    }
    addEventListener('resize',fitAll,{passive:true});
  };
  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(boot);
  else addEventListener('load',boot,{once:true});
  document.addEventListener('shopify:section:load',fitAll);
  document.addEventListener('shopify:section:select',fitAll);
})();